import { autoserialize, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class DriverBankTransactionType extends AbstractModel {
  @autoserialize name: string;

  @autoserialize description: string;
}
